import React, {useCallback, useState} from "react";
import styled from "styled-components";
import {ReactComponent as ToolTip} from 'assets/tooltip.svg';
import Button from "../Shared/Button";
import {ProfileBeaconError, ProfileBeaconIconButton,ProfileBeaconIcon, ProfileBeaconPopover, ProfileBeaconTooltip, ProfileBeaconControl} from "../Shared/ProfileBeaconComponents";
import {modalActions} from "../../redux/root-action";
import {modals} from "../../utils/constants";
import Input from "components/Shared/Input";
import {ReactComponent as DollarIcon} from "../../assets/dollar.svg";
import {ReactComponent as DollarErrorIcon} from "../../assets/dollarError.svg";
import {ReactComponent as PercentIcon }from "../../assets/percent.svg";
import Dropdown from "../Shared/Dropdown";
import {UseAppDispatch, UseAppSelector} from "../../redux/configure-store";
import _ from "lodash";
import {useCookies} from "react-cookie";
import {
    getClientProfile,
    getCompensations,
    getIsAnnualSalaryError,
    getIsClientProfileRejectedDataLoaded,
    getIsEditPlanInfoMode,
    getIsMarginalTaxRateError, getIsParticipantTerminated,
    getIsRetirementAgeError,
    getIsRixScenarioRejectedDataLoaded, getMultiClientCompensation,
    getPaycheckFrequencyOptions,
    getPersonalInformationData,
    getRetirementIncomeScenario,
    getSelectedPlan,
    getUpdatedAnnualSalary,
    getUpdatedMarginalTaxRate,
    getUpdatedPaycheckFrequency,
    getUpdatedRetirementAge
} from "../../redux/profile/selectors";
import {
    saveOrUpdateClientProfile,
    saveOrUpdateRiSimulation,
    saveRixSalaryPayFrequency,
    setIsAnnualSalaryError,
    setIsEditPlanInfoMode,
    setIsMarginalTaxRateError,
    setIsRetirementAgeError,
    setUpdatedAnnualSalary,
    setUpdatedMarginalTaxRate,
    setUpdatedPaycheckFrequency,
    setUpdatedRetirementAge,
    updateCompensations
} from "../../redux/profile/slice";
import {getDomain, isInternal} from "../../utils/api";
import useLocalizePhrase from "../../utils/useLocalizePhrase";

const StyledPlanInfo = styled.div`
  padding: 32px 40px;
  background-color: #fff;
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
`;

const StyledHeader = styled.div`
  border-bottom: 1px solid #bec3c8;
  font-family: "Nimbus Sans Novus Bold";
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StyledLinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 60px;
`;

const StyledTooltipContainer = styled.div.attrs((props: { isMarginalTaxRateError: boolean }) => props)`
  display: flex;
  font-family: "Nimbus Sans Novus Bold";
  justify-content: space-between;
`;

const StyledContainer = styled.div`
  margin-top: 16px;
  
`;


const StyledTitleContainer = styled.div`
  padding: 8px 0;
  height: 56px;
  display: flex;
  #paycheckFrequency{
    width:158px;
  }
    #retirementAge{
    padding-left:0px;}
    #marginalTaxRate{
    padding-left:0px;}
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;
  text-align: left;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledTitle = styled.div.attrs((props: { isEditPlanInfoMode: boolean, isMarginalTaxRateError: boolean }) => props)`
  font-family: "Nimbus Sans Novus Regular";
  @media (max-width: 1024px) {
    width: ${({isEditPlanInfoMode}) => isEditPlanInfoMode && "106px"};
  }
  // @media (max-width: 640px) {
  //   width: ${({isEditPlanInfoMode}) => isEditPlanInfoMode && "98px"};
  // }
`;
const StyledMultiClientText = styled.div`
  margin-top: 30px;
  @media (max-width: 768px) {
    margin-top: 16px;
  }
  @media (max-width: 640px) {
    text-align: center;
  }
  
`;
const StyledLink = styled.a`
  font-weight: var(--beacon-font-weight-bold);
  color: #086ea1;
  cursor: pointer;
`;

const StyledGrayedBox = styled.div`
  width: 170px;
  height: 40px;
  background: #767676;
  border-radius: 4px;
`;

const StyledTaxRateTitle = styled.div.attrs((props: { isEditPlanInfoMode: boolean }) => props)`
  font-family: "Nimbus Sans Novus Regular";
  display: flex;
  justify-content: space-between;
  align-items:center;
  @media (max-width: 1024px) {
    width: ${({isEditPlanInfoMode}) => isEditPlanInfoMode && "98px"};
    align-items: ${({isEditPlanInfoMode}) => isEditPlanInfoMode && "flex-end"};
    flex: ${({isEditPlanInfoMode}) => isEditPlanInfoMode && "0"};
  }
`;

const StyledValue = styled.div`
  font-family: "Nimbus Sans Novus Bold";
  text-align: right;
`;

const StyledButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 640px) {
    flex-direction: column-reverse;
    row-gap: 20px;
  }
`;


const StyledLinkButton = styled.div`
  margin-right: 16px;
  @media (max-width: 640px) {
    margin-right: 0;
  }
`;
const StyledErrorContainer = styled.div`
  display: flex;
  
  justify-content: right;
`;

const StyledError = styled(ProfileBeaconError)`
  @media (max-width: 1024px) {
    width: 170px;
  }
  
  
`;

const StyledInfoUnavailable = styled.div`
  font-family: "Nimbus Sans Novus Regular";
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledNoticeContainer = styled.div`
  margin-top: 8px;
  padding: 32px 24px;
  border-radius: 4px;
  border: solid 1px #ffad00;
  background-color: rgba(255, 173, 0, 0.16);
  font-family: "Nimbus Sans Novus Regular";
  text-align: left;
  color: #3b4b59;
  @media (max-width: 768px) {
    padding: 24px;
  }
  @media (max-width: 640px) {
    padding: 24px 16px;
  }
`;

const StyledNoticeHeader = styled.div`
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.02px;
  font-family: "Nimbus Sans Novus Bold";
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }
`;

const StyledNoticeContent = styled.div`
  padding-top: 16px;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.02px;

  a {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding-top: 8px;
    line-height: 1.43;
  }

`;

export const PlanningInformationCard = () => {
    const saveButtonTitle = useLocalizePhrase('Save');
    const editButtonTitle = useLocalizePhrase('Edit');
    const planningInformationTitle = useLocalizePhrase('Planning Information');
    const annualSalaryTitle = useLocalizePhrase('Annual Salary');
    const preferedRetirementAgeTitle = useLocalizePhrase('Preferred Retirement Age');
    const marginalTaxRateTitle = useLocalizePhrase('Marginal Tax Rate');
    const paycheckFrequencyTitle = useLocalizePhrase('Paycheck Frequency');
    const notEnteredTitle = useLocalizePhrase('Not Entered');
    const weeklyTitle = useLocalizePhrase('Weekly');
    const biweeklyTitle = useLocalizePhrase('Biweekly');
    const twiceAMonthTitle = useLocalizePhrase('Twice A Month');
    const monthlyTitle = useLocalizePhrase('Monthly');
    const dispatch = UseAppDispatch();
    const showMarginalTaxRateModal = useCallback(() => {
        dispatch(modalActions.showModal(modals.MARGINAL_TAX_RATE_MODAL));
    }, [dispatch]);

    const isEditPlanInfoMode = UseAppSelector(getIsEditPlanInfoMode);

    const updatedAnnualSalary = UseAppSelector(getUpdatedAnnualSalary);
    const updatedRetirementAge = UseAppSelector(getUpdatedRetirementAge);
    const clientProfile = UseAppSelector(getClientProfile);

    const marginalTaxRate = clientProfile?.attributes?.find((attribute: any) =>
        attribute.attributeType.typeCd === "MTRT"
    )?.amount;
    const updatedMarginalTaxRate = UseAppSelector(getUpdatedMarginalTaxRate);

    const isAnnualSalaryError = UseAppSelector(getIsAnnualSalaryError);
    const isRetirementAgeError = UseAppSelector(getIsRetirementAgeError);
    const isMarginalTaxRateError = UseAppSelector(getIsMarginalTaxRateError);
    const [cookies, setCookies] = useCookies();
    const uberId = cookies["cl-uber"];
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const planNumber = selectedPlan.value;
    const retirementIncomeScenario = UseAppSelector(getRetirementIncomeScenario);
    const filterCompensations = retirementIncomeScenario?.compensations?.filter((compensation: any) => compensation.bpId == retirementIncomeScenario?.participantProfile?.bpId);
    const annualSalary = (retirementIncomeScenario == null || retirementIncomeScenario?.participantProfile == null || retirementIncomeScenario?.participantProfile?.bpId === null) || retirementIncomeScenario?.compensations == null || filterCompensations.length === 0 ? 0.0 : filterCompensations.length === 1 ? filterCompensations[0].amount : filterCompensations.reduce((a,b) => { return a + b.amount}, 0);
    const retirementAge = retirementIncomeScenario?.retirementStartAge;
    const getPersonalInfoData = UseAppSelector(getPersonalInformationData);
    const dateOfBirth: any = new Date(getPersonalInfoData?.birthDate);
    const participantAge = Math.floor((Date.now() - dateOfBirth) / (1000 * 3600 * 24) / 365);
    const retirementEndAge = 94;
    const compensations = UseAppSelector(getCompensations);
    const paycheckFreqOptions = UseAppSelector(getPaycheckFrequencyOptions);
    const isRixScenarioRejectedDataLoaded = UseAppSelector(getIsRixScenarioRejectedDataLoaded);
    const isGetClientProfileRejectedDataLoaded = UseAppSelector(getIsClientProfileRejectedDataLoaded);
    const isMultiClientCompensation = UseAppSelector(getMultiClientCompensation);
    const isTerminatedParticipant = UseAppSelector(getIsParticipantTerminated);
    const isParticipantTerminatedWithNoSalary = isTerminatedParticipant && (compensations.length == 0);

    const [showNotice, setShowNotice] = useState(false);
    const paycheckFrequencyOptions = paycheckFreqOptions?.map((data: any) => {
        let optionName = data.fullname;

        switch (data.code) {
            case 'WKLY':
                optionName = weeklyTitle;
                break;
            case 'BIWK':
                optionName = biweeklyTitle;
                break;
            case 'TWMO':
                optionName = twiceAMonthTitle;
                break;
            case 'MTLY':
                optionName = monthlyTitle;
                break;
        }

        return {
            "name": optionName,
            "value": data.code,
            "id": data.valueIdentifier
        }
    }) || [];

    const payFrequency = retirementIncomeScenario?.compensations && retirementIncomeScenario?.compensations[0]?.payFrequency;
    let paycheckFrequencyCode: number;
    switch (payFrequency) {
        case "WKLY":
            paycheckFrequencyCode = 460;
            break;
        case "BIWLY":
            paycheckFrequencyCode = 461;
            break;
        case "TWMLY":
            paycheckFrequencyCode = 462;
            break;
        case "MLY":
            paycheckFrequencyCode = 463;
            break;
    }

    const paycheckFrequency = paycheckFrequencyOptions.filter((option: any) => option.id === paycheckFrequencyCode);
    const paycheckFrequencyValue = useLocalizePhrase(paycheckFrequency.length > 0 ? paycheckFrequency[0]?.name || '' : '');
    const getUpdatedPayFrequency = UseAppSelector(getUpdatedPaycheckFrequency);
    const defaultPayFreqOption = "WKLY";
    const updatedPaycheckFrequency = getUpdatedPayFrequency ? getUpdatedPayFrequency : paycheckFrequency.length > 0 ? paycheckFrequency[0]?.value : defaultPayFreqOption;
    const isSavePlanInfoDisabled = isAnnualSalaryError || isRetirementAgeError || isMarginalTaxRateError || (updatedMarginalTaxRate === marginalTaxRate && (isParticipantTerminatedWithNoSalary || updatedAnnualSalary.toLocaleString() === annualSalary.toLocaleString()) && updatedRetirementAge === retirementAge && (isParticipantTerminatedWithNoSalary || updatedPaycheckFrequency === paycheckFrequency[0]?.value));
    const handleEditPlanInfo = () => {
        dispatch(setIsEditPlanInfoMode(true))
    }
    const handleCancelPlanInfo = () => {
        dispatch(setIsEditPlanInfoMode(false))
        dispatch(setUpdatedAnnualSalary(annualSalary));
        dispatch(setUpdatedRetirementAge(retirementAge));
        dispatch(setUpdatedMarginalTaxRate(marginalTaxRate));
        dispatch(setUpdatedPaycheckFrequency(paycheckFrequency[0]?.value));
        dispatch(setIsAnnualSalaryError(false));
        dispatch(setIsRetirementAgeError(false));
        dispatch(setIsMarginalTaxRateError(false));
    }
    const handleSalaryChange = (event: any) => {
        let value = event.target.value;
        const tempValue = value.replace(/[A-Za-z!@#$%^&*.(){}_;'\[\]\-\'"+=:<>?\/\|\\\`~ ,]/gi, "");
        const salary = parseInt(tempValue);
        if (salary >= 15000){
            dispatch(setIsAnnualSalaryError(false));
            // event.target.style.color="inherit";
        }
        const commaSeparatedValue = tempValue.split(/(?=(?:\d{3})+$)/).join(",");
        value = commaSeparatedValue;
        event.target.value = value;
        dispatch(setUpdatedAnnualSalary(value));
    }

    const handleAgeChange = (event: any) => {
        event.target.value=event.target.value.slice(0,2);
        if (+event.target.value >= participantAge && event.target.value <= retirementEndAge){
            dispatch(setIsRetirementAgeError(false));
            // event.target.style.color="inherit";
        }
            
        dispatch(setUpdatedRetirementAge(parseInt(event.target.value)));
    }
    const handleTaxRateChange = (event: any) => {
      
        event.target.value=event.target.value.slice(0,3);
        if (event.target.value > 100){
            dispatch(setIsMarginalTaxRateError(true));
            // event.target.style.color="#dd3636";
        }

        else{
            dispatch(setIsMarginalTaxRateError(false));
            // event.target.style.color="";
        }

        dispatch(setUpdatedMarginalTaxRate(parseInt(event.target.value)));
    }
    const handlePaycheckFrequencyChange = (event: any) => {
        dispatch(setUpdatedPaycheckFrequency(event.target.value));
    }
    const handleSavePlanInfo = useCallback((updatedAnnualSalary, updatedRetirementAge, updatedMarginalTaxRate, updatedPaycheckFrequency, clientProfile, retirementIncomeScenario, compensations) => {
        const amount = parseInt(updatedAnnualSalary.toString().replace(/,/gi, ""));
        if ((amount == undefined || amount < 15000 || updatedAnnualSalary == "" && !isMultiClientCompensation && !isParticipantTerminatedWithNoSalary) && ((updatedRetirementAge < participantAge) || (updatedRetirementAge > retirementEndAge))) {
            dispatch(setIsAnnualSalaryError(true))
            dispatch(setIsRetirementAgeError(true))
            // document.getElementById('retirementAge').style.color="#dd3636";
            return;
        } else {
            dispatch(setIsAnnualSalaryError(false))
            dispatch(setIsRetirementAgeError(false))
            // document.getElementById('retirementAge').style.color=" ";
        }
        if (amount == undefined || amount < 15000 || updatedAnnualSalary == "" && !isMultiClientCompensation && !isParticipantTerminatedWithNoSalary) {
            dispatch(setIsAnnualSalaryError(true))
            return;
        } else
            dispatch(setIsAnnualSalaryError(false))
        if ((updatedRetirementAge < participantAge) || (updatedRetirementAge > retirementEndAge)) {
            dispatch(setIsRetirementAgeError(true))
            // document.getElementById('retirementAge').style.color="#dd3636";
            return;
        } else{
            dispatch(setIsRetirementAgeError(false))
            // document.getElementById('retirementAge').style.color=" ";
        }
        if ((updatedRetirementAge != null && updatedRetirementAge != 0 && updatedRetirementAge != retirementAge) || (amount > 0 && amount != null && amount != annualSalary)) {
            setShowNotice(true);
        }
        if (updatedMarginalTaxRate && updatedMarginalTaxRate !== marginalTaxRate) {
            let profileAlreadyExists = false;
            if (!(_.isEmpty(clientProfile)))
                profileAlreadyExists = true;
            let clientProfileAttributes = [];
            if (clientProfile?.attributes?.length > 0) {
                clientProfileAttributes = clientProfile?.attributes?.map((clientProfileAttribute: any) => {
                    return {
                        ...clientProfileAttribute,
                        amount: clientProfileAttribute.attributeType.typeId === 459 ? parseFloat(updatedMarginalTaxRate) : clientProfileAttribute.amount,
                        clientProfileEffectiveTimestamp: clientProfile.effectiveTimestamp == null ? "" : clientProfile.effectiveTimestamp,
                        effectiveTimestamp: clientProfile.effectiveTimestamp == null ? "" : clientProfile.effectiveTimestamp,
                        expirationTimestamp: clientProfile.expirationTimestamp == null ? "" : clientProfile.expirationTimestamp,
                        date: clientProfileAttribute.date == null ? "" : clientProfileAttribute.date.toString(),
                        value: clientProfileAttribute.value == null ? 0 : clientProfileAttribute.value,
                        text: clientProfileAttribute.text == null ? "" : clientProfileAttribute.text,
                        timestamp: clientProfileAttribute.timestamp == null ? "" : clientProfileAttribute.timestamp.toString(),
                        indicator: clientProfileAttribute.indicator == null ? false : clientProfileAttribute.indicator,
                        referenceType: clientProfileAttribute.referenceType == null ? 0 : clientProfileAttribute.referenceType,
                        referenceValue: clientProfileAttribute.referenceValue == null ? 0 : clientProfileAttribute.referenceValue
                    }
                });
            } else {
                const taxRateAttribute = {
                    "uberId": uberId,
                    "attributeType": {
                        "typeId": 459,
                        "typeCd": "MTRT",
                        "typeName": "Marginal Tax Rate"
                    },
                    "clientProfileEffectiveTimestamp": "",
                    "sequenceNumber": 0,
                    "effectiveTimestamp": "",
                    "expirationTimestamp": "",
                    "date": "",
                    "value": 0,
                    "text": "",
                    "timestamp": "",
                    "amount": parseFloat(updatedMarginalTaxRate),
                    "indicator": false,
                    "referenceType": 0,
                    "referenceValue": 0,
                    "origUserId": "RWS",
                    "origTimeStamp": "",
                    "lastUpdatedUserId": "RWS",
                    "lastUpdatedTimeStamp": ""
                }
                clientProfileAttributes.push(taxRateAttribute)
            }
            let profile = {
                uberId: uberId,
                genderType: clientProfile?.genderType ? clientProfile?.genderType : {},
                financialExperienceLevelType: clientProfile?.financialExperienceLevelType ? clientProfile?.financialExperienceLevelType : {},
                investmentsGoals: clientProfile?.investmentsGoals && clientProfile?.investmentsGoals?.length > 0 ? clientProfile?.investmentsGoals : [],
                attributes: clientProfileAttributes,
                effectiveTimestamp: "",
                expirationTimestamp: "",
                origUserId: "RWS",
                origTimeStamp: "",
                lastUpdatedUserId: "RWS",
                lastUpdatedTimeStamp: ""
            }
            dispatch(saveOrUpdateClientProfile({profile, profileAlreadyExists}))
        }
        let payFreq: string;
        switch (updatedPaycheckFrequency) {
            case "BIWK":
                payFreq = "BIWLY";
                break;
            case "TWMO":
                payFreq = "TWMLY";
                break;
            case "MTLY":
                payFreq = "MLY";
                break;
            default:
                payFreq = updatedPaycheckFrequency;
                break;
        }

        if (payFreq !== "" || updatedAnnualSalary !== "") {
            if ((payFreq !== payFrequency) || updatedMarginalTaxRate || (updatedAnnualSalary && (updatedAnnualSalary !== annualSalary))) {
                if (!(_.isEmpty(compensations)) && compensations.length == 1) {
                    const compensation = compensations.map((comp: any) => {
                        const filteredCompensation = _.pickBy(comp, (value : any) => value != null);
                        return {
                                ...filteredCompensation,
                                amount: amount,
                                payFrequency: payFreq,
                                compensationType: comp.compensationType != null ? comp.compensationType : "ASLRY"
                            }
                    })
                    dispatch(updateCompensations({compensations: compensation}))
                } else if(compensations != null && compensations.length == 0){
                    let paycheckFrequencyCode: number;
                    switch (payFreq) {
                        case "WKLY":
                            paycheckFrequencyCode = 460;
                            break;
                        case "BIWLY":
                            paycheckFrequencyCode = 461;
                            break;
                        case "TWMLY":
                            paycheckFrequencyCode = 462;
                            break;
                        case "MLY":
                            paycheckFrequencyCode = 463;
                            break;
                    }
                    compensations.map((compensation: any) => {
                        if (compensation.amount > 0.0) {
                            const userEnteredCompensation = {
                                "annualSalary": amount,
                                "payFrequency": paycheckFrequencyCode,
                                "planNumber": planNumber
                            }
                            dispatch(saveRixSalaryPayFrequency({userEnteredCompensation}))
                        }
                    })
                }
            }
            let rixScenario;
            if (retirementAge !== updatedRetirementAge) {
                rixScenario = {
                    "retirementStartAge": parseInt(updatedRetirementAge),
                }
                dispatch(saveOrUpdateRiSimulation({rixScenario}))
            }
        }
        dispatch(setIsEditPlanInfoMode(false))
    }, [dispatch]);

    const loadRetirementIncomePage = () => {
        document.location.href = getDomain() + "/workplace/en/participant/ri/index.html";
    }
    const goToRIPlannerPage = () => {
         document.location.href= getDomain() + "/workplace/en/participant/no-salary.html?returnURL=" + getDomain() + "/workplace/en/participant/profile/index.html";
    }
    return (
        <StyledPlanInfo>
            <StyledHeader>
                {planningInformationTitle}
                {!isRixScenarioRejectedDataLoaded && !isGetClientProfileRejectedDataLoaded ?
                    <StyledLinkContainer>
                        <Button key={editButtonTitle} variant="tertiary" isIcon={true} buttonTitle={editButtonTitle} onBeaconClick={() => !isInternal() && handleEditPlanInfo()}
                                disabled={isEditPlanInfoMode || isInternal()}/>
                    </StyledLinkContainer> : ""}
            </StyledHeader>
            <StyledContainer>
                {!isRixScenarioRejectedDataLoaded && !isGetClientProfileRejectedDataLoaded ?
                    <>
                        {isAnnualSalaryError &&
                            <StyledErrorContainer><StyledError slot='error'>
                                Enter an amount greater than or equal to $15,000
                            </StyledError>
                                </StyledErrorContainer>}
                        <StyledTitleContainer className="blocked_data">
                            <StyledTitle isEditPlanInfoMode={isEditPlanInfoMode}>{annualSalaryTitle}</StyledTitle>
                            {isEditPlanInfoMode ?
                                <Input    
                                    id="annualSalary" 
                                    isPlanInfo={true}
                                    name="annualSalary"
                                    value={updatedAnnualSalary.toLocaleString()}
                                    prefix="$"
                                    onInput={handleSalaryChange}
                                    isPlanInfoError={isAnnualSalaryError}
                                    disabled={isMultiClientCompensation || isParticipantTerminatedWithNoSalary}/>     
                               :
                                <StyledValue>{annualSalary ? "$" + annualSalary.toLocaleString() : notEnteredTitle}</StyledValue>}
                        </StyledTitleContainer>
                        {isRetirementAgeError &&
                            <StyledErrorContainer>
                                <StyledError slot="error">{`Enter a retirement age between ${participantAge} and ${retirementEndAge}`}</StyledError>
                                    </StyledErrorContainer>}
                        <StyledTitleContainer className="blocked_data">
                            <StyledTitle isEditPlanInfoMode={isEditPlanInfoMode}>{preferedRetirementAgeTitle}</StyledTitle>
                            
                            {isEditPlanInfoMode ?
                                <Input 
                                    // type="text" 
                                    style="color:red !important;"
                                    id="retirementAge"
                                    isPlanInfo={true}
                                    name="retirementAge" 
                                    label="Retirement age" 
                                    format="00"
                                    formatType="pattern"
                                    value={updatedRetirementAge.toString()}
                                    onInput={handleAgeChange}
                                    isPlanInfoError={isRetirementAgeError}/>
                                  
                                   
                                  
                                   
                                    
                                : 
                                <StyledValue>{retirementAge ? retirementAge : "65"}</StyledValue>}
                                 
                        </StyledTitleContainer>
                        {isMarginalTaxRateError 
                        && <StyledErrorContainer>
                            <StyledError slot='error'>Enter an amount less than or equal to 100%</StyledError>
                        </StyledErrorContainer>
                        }
                        <StyledTitleContainer className="blocked_data">
                            <StyledTaxRateTitle isEditPlanInfoMode={isEditPlanInfoMode}>{marginalTaxRateTitle}
                               
                                      <ProfileBeaconIconButton variant="tertiary" name="information" label="Current yield" slot="action-zone" id="header-tooltip-1" onClick={showMarginalTaxRateModal}><ToolTip/></ProfileBeaconIconButton>
                            </StyledTaxRateTitle>
                            {isEditPlanInfoMode ?
                            
                                //    <ProfileBeaconControl>
                                //     <input
                                //     isPlanInfo={true}
                                //     name="marginalTaxRate" 
                                //     label="Marginal tax rate" 
                                //     id="marginalTaxRate" 
                                //     format="000" 
                                //     className="error"
                                //     errorMessage={isMarginalTaxRateError?undefined:"Enter an amount less than or equal to 100%"}
                                //     formatType="pattern" 
                                //     suffix="%"
                                //     value={updatedMarginalTaxRate.toString()}
                                //     isPlanInfoError={true}
                                //     onInput={handleTaxRateChange}
                                //     customValidate={(event)=>event.target.setCustomValidity(isMarginalTaxRateError?'':"Enter an amount less than or equal to 100%")}
                                //     /> 
                                //     <span slot="error">
                                //    </ProfileBeaconControl>
                                        <Input
                                         
                                         isPlanInfo={true}
                                         name="marginalTaxRate" 
                                         label="Marginal tax rate" 
                                         id="marginalTaxRate" 
                                         format="000" 
                                         className="error"
                                        //  errorMessage={isMarginalTaxRateError?undefined:"Enter an amount less than or equal to 100%"}
                                         formatType="pattern" 
                                         suffix="%"
                                         value={updatedMarginalTaxRate.toString()}
                                         isPlanInfoError={isMarginalTaxRateError}
                                         onInput={handleTaxRateChange}
                                        //  customValidate={(event)=>event.target.setCustomValidity(isMarginalTaxRateError?'':"Enter an amount less than or equal to 100%")}
                                         
                                         
                                         />
                                       
                                :
                                <StyledValue>{marginalTaxRate ? marginalTaxRate + "%" : notEnteredTitle}</StyledValue>}
                        </StyledTitleContainer>
                        <StyledTitleContainer className="blocked_data">
                            <StyledTitle isEditPlanInfoMode={isEditPlanInfoMode}>{paycheckFrequencyTitle}</StyledTitle>
                            {isEditPlanInfoMode ?
                                <Dropdown 
                                    name="paycheckFrequency" 
                                    id="paycheckFrequency"
                                    isPlanInfo={true}
                                    hideDropdownLabel={true}
                                    value={updatedPaycheckFrequency}
                                    options={paycheckFrequencyOptions} 
                                    onInput={handlePaycheckFrequencyChange}
                                    label="Paycheck frequency"
                                    disabled={isMultiClientCompensation || isParticipantTerminatedWithNoSalary}
                                    /> :
                                <StyledValue>{paycheckFrequency.length > 0 ? paycheckFrequencyValue : notEnteredTitle}</StyledValue>}
                        </StyledTitleContainer>
                        {(isMultiClientCompensation || isParticipantTerminatedWithNoSalary) && isEditPlanInfoMode &&
                            <StyledMultiClientText><StyledLink onClick={() => goToRIPlannerPage()}>Update Your Annual Salary and/or Paycheck Frequency</StyledLink></StyledMultiClientText>
                        }
                        {isEditPlanInfoMode &&
                            <StyledButtonContainer>
                                <StyledLinkButton><Button variant="tertiary" isLink={true} buttonTitle="Cancel"
                                                          onBeaconClick={() => handleCancelPlanInfo()}/></StyledLinkButton>
                                <Button buttonTitle={saveButtonTitle} disabled={isSavePlanInfoDisabled}
                                        onBeaconClick={() => handleSavePlanInfo(updatedAnnualSalary, updatedRetirementAge, updatedMarginalTaxRate, updatedPaycheckFrequency, clientProfile, retirementIncomeScenario, compensations)}/>
                            </StyledButtonContainer>}

                    </>
                    :
                    <StyledInfoUnavailable>
                        The requested information is unavailable.
                    </StyledInfoUnavailable>

                }
                {(!isEditPlanInfoMode && showNotice) &&
                    <StyledNoticeContainer>
                        <StyledNoticeHeader>Notice</StyledNoticeHeader>
                        <StyledNoticeContent>
                            To view the impact your updated salary or preferred retirement age has on your Confidence
                            Number, please visit <a onClick={() => loadRetirementIncomePage()}>Retirement Income</a>.
                        </StyledNoticeContent>
                    </StyledNoticeContainer>
                }
            </StyledContainer>
        </StyledPlanInfo>
    )
}